import { Button, Typography, Spin, Empty, Divider } from "antd";
import React, { useEffect, useRef, useState } from "react";


import { CloseOutlined } from '@ant-design/icons'

import { apiCall } from "../utils/Api";
import Title from "./Title";
export default function SeriesCount(props) {


    const { isbn = "", setUnderFlow = () => { }, drawComponent = () => { }, next = false, series = "", series_num = "" } = props;
    const [drawn, setDrawn] = useState(false);
    // Fetch next or previous series 
    const getSeries = (_next = false) => {

        setUnderFlow(<DrawTitles titles={{ rows: [] }} next={_next} loading={true} />);

        apiCall((_next) ? "title/getNextInSeries" : "title/getPreviousInSeries", { isbn: isbn }, (_status, _result) => {
            if (_status) {
                setUnderFlow(<DrawTitles titles={_result} next={_next} loading={false} />);
            }
        });
    }

    // Draw results + shift page down
    const DrawTitles = (props) => {
        const { titles = { rows: [] }, next = false, loading = true } = props;
        const myRef = useRef(null);

        // Shift down to the placeholder - no sense waiting for results to load...
        useEffect(() => {
            if (loading) { myRef.current.scrollIntoView({ behavior: "smooth", block: 'start', inline: 'nearest' }); }
        }, [])


        //     position: absolute;
        // left: -20px;
        // top: 0;
        // bottom: 0; 
        // width: 20px;
        // background: #444;
        // cursor: pointer;


        return (
            <div style={{ "position": "relative" }}>
                {/* Title and close UI */}
                <div style={{ "position": "relative", "top": "-174px" }} ref={myRef} ></div>


                <div style={{ "marginTop": "0px", "marginLeft" : "-10px", "borderTop": "none", "backgroundColor": "#f1f1f1" }} className="closebar">
                    <Button onClick={() => {
                        setUnderFlow("")
                        myRef.current.scrollIntoView({ behavior: "smooth", block: 'start', inline: 'nearest' });

                    }} style={{ "float": "right" }} size="small" type="text" icon={<small><CloseOutlined style={{ "fontSize": "10px", "color": "#111" }} /></small>} />
                    <br clear="both" />
                </div>

                <div className="closebar">
                    <div style={{ "padding": "8px 0px", "paddingBottom": "0px" }}>
                        <Typography.Title style={{ "lineHeight": "17px" }} level={5}>
                            <div>{(next) ? "Next in series:" : "Previous in series:"} {series}{series_num}</div>
                        </Typography.Title>
                    </div>
                </div>


                <div className="shim" /><div className="shim" /><div className="shim" /><div className="shim" />

                {/* Loading animation */}
                {(loading && <>
                    <Spin spinning={loading}>
                        <div className="shim" style={{ "height": "200px" }}></div>
                    </Spin>
                </>)}

                <div  style={{ "position": "absolute", "left": "-30px", "width": "20px", "textAlign": "center", "backgroundColor": "#0000000E", "bottom": "0", "top": "0", "cursor": "pointer" }} onClick={() => setUnderFlow("")} >
                    <CloseOutlined style={{ "fontSize": "10px" }} />
                </div>

                {/* Results */}
                <div>
                    {titles.rows.map((item, index) => {
                        return (
                            <div>
                                <Title view={"details"} data={item} />
                                {(index !== (titles.rows.length - 1) && <div className="borderBottom shim" style={{ "margin": "25px -20px", "borderBottomWidth": "6px" }} />)}
                            </div>
                        )
                    })}
                </div>

                {/* Empty */}
                {((!loading && titles.rows.length === 0) && <>
                    <div>
                        <Empty description="No series found." image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </div>
                </>)}
            </div>
        )
    }

    // Buttons
    return (

        <Button size="small" onClick={() => getSeries(next)} className="mini-btn" ><small>{(next) ? "Next" : "Previous"} in Series</small></Button>


    )





}